import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';

interface AcquisitionOption {
  value: string;
  label: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'globot-acquisition-source-modal',
  templateUrl: './acquisition-source-modal.component.html',
  styleUrls: ['./acquisition-source-modal.component.scss'],
})
export class AcquisitionSourceModalComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Output() closed = new EventEmitter<void>();

  options: AcquisitionOption[] = [
    { value: 'google', label: 'Google / Web', description: 'Búsqueda en internet', icon: 'pi-search' },
    {
      value: 'ai_recommendation',
      label: 'Recomendación de IA',
      description: 'ChatGPT, Gemini, Copilot...',
      icon: 'pi-bolt',
    },
    { value: 'recommendation', label: 'Recomendación', description: 'Un colega o conocido', icon: 'pi-users' },
    { value: 'social_media', label: 'Redes sociales', description: 'Instagram, TikTok, Facebook...', icon: 'pi-instagram' },
    { value: 'linkedin', label: 'LinkedIn', description: 'Publicación profesional', icon: 'pi-linkedin' },
    { value: 'news', label: 'Noticia', description: 'Leíste sobre nosotros', icon: 'pi-book' },
    { value: 'other', label: 'Otro', description: 'Cuéntanos cómo', icon: 'pi-plus' },
    {
      value: 'prefer_not_to_say',
      label: 'Prefiero no decir',
      description: 'Omitir esta pregunta',
      icon: 'pi-minus-circle',
    },
  ];

  selectedSource: string | null = null;
  otherText: string = '';
  saving: boolean = false;

  constructor(private userService: UserService) {}

  ngOnChanges(): void {
    if (this.visible) {
      this.selectedSource = null;
      this.otherText = '';
      this.saving = false;
    }
  }

  selectOption(value: string): void {
    this.selectedSource = value;
    if (value !== 'other') {
      this.otherText = '';
    }
  }

  get canSave(): boolean {
    if (!this.selectedSource) return false;
    if (this.selectedSource === 'other') return this.otherText.trim().length > 0;
    return true;
  }

  save(): void {
    if (!this.canSave || this.saving) return;
    this.saving = true;
    const source = this.selectedSource === 'other' ? this.otherText.trim() : this.selectedSource!;
    this.userService.updateAcquisitionSource(source).subscribe({
      next: () => {
        this.userService.updateLocalAcquisitionSource(source);
        this.saving = false;
        this.closed.emit();
      },
      error: () => {
        this.saving = false;
      },
    });
  }

}
